import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import Button from '../components/common/Button';
import Input from '../components/common/Input';
import { updateUserProfile } from '../services/database';
import { geocodeAddress } from '../services/geocoding';
import { toast } from 'react-toastify';
import './CompleteProfilePage.css';

const CompleteProfilePage: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const redirectPath = searchParams.get('redirect') || '/home';
  const { currentUser, refreshProfile } = useAuth();
  const [loading, setLoading] = useState(false);

  const [street, setStreet] = useState('');
  const [city, setCity] = useState('');
  const [county, setCounty] = useState('');
  const [eircode, setEircode] = useState('');
  const [phone, setPhone] = useState('');

  const handleComplete = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!street || !city || !phone) {
      toast.error('Please fill in all required fields');
      return;
    }

    setLoading(true);
    try {
      // Geocode the address
      const fullAddress = `${street}, ${city}, ${county || ''}, Ireland`;
      const coords = await geocodeAddress(fullAddress);

      await updateUserProfile(currentUser!.uid, {
        phone,
        shippingAddress: {
          street,
          city,
          state: county || '',
          zipCode: eircode.toUpperCase(),
          country: 'Ireland',
          latitude: coords?.lat || null,
          longitude: coords?.lng || null,
        },
      } as any);

      await refreshProfile();
      toast.success('Profile completed!');
      navigate(redirectPath);
    } catch (error) {
      console.error('Error completing profile:', error);
      toast.error('Failed to save profile');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="complete-profile-page">
      <div className="complete-profile-container">
        <h1>Welcome!</h1>
        <p className="subtitle">Let's complete your profile to get started</p>

        <form onSubmit={handleComplete}>
          <h2 className="section-title">Shipping Address</h2>

          <Input
            label="Street Address *"
            placeholder="123 Main Street"
            value={street}
            onChange={(e) => setStreet(e.target.value)}
            required
          />

          <Input
            label="City/Town *"
            placeholder="Dublin"
            value={city}
            onChange={(e) => setCity(e.target.value)}
            required
          />

          <div className="row-inputs">
            <Input
              label="County"
              placeholder="Dublin"
              value={county}
              onChange={(e) => setCounty(e.target.value)}
            />
            <Input
              label="Eircode"
              placeholder="D02 XY45"
              value={eircode}
              onChange={(e) => setEircode(e.target.value.toUpperCase())}
            />
          </div>

          <h2 className="section-title">Contact Information</h2>

          <Input
            label="Phone Number *"
            type="tel"
            placeholder="087 123 4567"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            required
          />

          <Button type="submit" fullWidth loading={loading} style={{ marginTop: '32px' }}>
            Complete Profile
          </Button>
        </form>
      </div>
    </div>
  );
};

export default CompleteProfilePage;
